import { ArrowRightIcon } from '@heroicons/react/solid';
import { Image } from '@storyofams/storyblok-toolkit';

import { classNames } from '~/lib';
import { Heading } from '../Heading';
import { Link } from '../Link';

interface ArticleCardProps {
  article: {
    uuid?: string;
    slug?: string;
    content?: any;
  };
  featured?: boolean;
  grid?: boolean;
}

export const ArticleCard = ({ article, featured, grid }: ArticleCardProps) => {
  const { uuid, slug, content } = article;

  return (
    <div className={classNames('w-full')} key={uuid}>
      <Link
        href={`/blog/${slug}`}
        className={classNames(
          'flex flex-col w-full group justify-between h-full',
        )}
        key={uuid}
      >
        <div
          className={classNames(
            'flex flex-col',
            featured &&
              'md:flex-row md:items-center md:space-x-8 lg:space-x-12',
          )}
        >
          <div
            className={classNames(
              'mb-8 lg:ml-0 lg:mr-0 rounded-2xl overflow-hidden image--rounded w-full md:max-w-[532px]',
            )}
          >
            <div
              className={classNames(
                'w-full relative',
                featured
                  ? 'h-64 md:h-96'
                  : grid
                  ? 'h-64'
                  : 'max-h-80 lg:max-h-112',
              )}
            >
              <p
                className={classNames(
                  'px-3 py-1 bg-gray-50 border border-gray-100 rounded-full absolute left-4 top-4 z-10 text-grey-700 text-sm',
                  !grid && 'md:text-base md:left-6 md:top-6',
                )}
              >
                {featured ? 'Featured' : content?.category || content.type}
              </p>

              <Image
                alt={content?.thumbnail?.alt || ''}
                src={content?.thumbnail?.filename}
                fluid={800}
                fit="cover"
                showPlaceholder={false}
                width="100%"
                height="100%"
              />
            </div>
          </div>

          <div className="w-full md:max-w-[524px]">
            <Heading
              variant="h5"
              as="h2"
              className={classNames(grid && '!text-xl')}
            >
              {content?.title}
            </Heading>
            <p className={classNames('text-gray-500 mt-3', grid && 'text-sm')}>
              {content?.synopsis}
            </p>
            {featured && (
              <p className="flex items-center text-gray-800 mt-10 md:mt-14">
                Read more
                <ArrowRightIcon
                  className="w-4 h-4 ml-2 -mb-0.25 transition-transform group-hover:translate-x-0.5"
                  aria-hidden="true"
                />
              </p>
            )}
          </div>
        </div>

        {!featured && (
          <div>
            <p
              className={classNames(
                'inline-flex items-center text-gray-800 mt-8 md:mt-10',
                grid && 'text-sm',
              )}
            >
              Read more
              <ArrowRightIcon
                className={classNames(
                  'ml-2 -mb-0.25 transition-transform group-hover:translate-x-0.5',
                  grid ? 'w-3 h-3' : 'w-4 h-4',
                )}
                aria-hidden="true"
              />
            </p>
          </div>
        )}
      </Link>
    </div>
  );
};
